// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Custom Event polyfill
import 'custom-event-polyfill/polyfill';

// Match Height
import 'jquery-match-height/dist/jquery.matchHeight';

// Magnific Popup
import 'magnific-popup/dist/jquery.magnific-popup';

// Import Axios
import 'axios/dist/axios.min';

// Import Qs
import 'qs/dist/qs';

// JQuery Visible
import 'jquery-visible';

// Cookie Consent
import 'cookieconsent/src/cookieconsent';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateLastestNews from './routes/news';
import videos from './routes/videos';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  //Latest news template
  templateLastestNews,
  //Videos
  videos,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js